<template>
<div>
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
  <loading :active.sync="loaderFull" :can-cancel="false" :is-full-page="true"></loading>
<Header/>
  <b-card class="bCardGlobalXL" >
    <div class="divSubtitulo">
      <p class="textoSubtitulo">Nueva promoción</p>
    </div>



    <div>
      <br/>
      <br/>
      <b-row class="text-left">

          <b-col cols = "6">
              <b-form-input
                  placeholder="Nombre de la promoción"
                  v-model="nombrePromo"
                  type="text"
                  :state="nombrePromo != null && nombrePromo !== '' "
                  required
              ></b-form-input>
<!--        <b-form-invalid-feedback :state="nombrePromo != null || nombrePromo != ''">
              El nombre es requerido
            </b-form-invalid-feedback>-->
          </b-col>
        <b-col cols="4">
        </b-col>
        <b-col cols="2" class="text-center">
          <div v-if="estado === 1" style="background-color: rgb(22 101 165); color: #FFFFFF; padding: 5px; border-radius: 25px;">
            PROGRAMADA
          </div>
          <div v-if="estado === 2" style="background-color: rgb(61 173 84); color: #FFFFFF; padding: 5px; border-radius: 25px;">
            ACTIVA
          </div>
          <div v-if="estado === 3" style="background-color: rgb(165 81 22); color: #FFFFFF; padding: 5px; border-radius: 25px;">
            TERMINADA
          </div>
          <div v-if="estado === 4" style="background-color: rgb(235 245 253); color: rgb(121 166 187); padding: 5px; border-radius: 25px;">
            SUSPENDIDO
          </div>
        </b-col>
      </b-row>
    </div>
    <br/>
    <div class="text-left">
      <span class="subEspacios">Datos generales</span>

      <b-row class="text-left" style="margin-top: 18px;">
        <b-col cols="2">
          <label style="font-size: 12px">Categoria</label>
        </b-col>
        <b-col cols = "6">
          <v-select
              v-model="idCategoriaPromocion"
              :options="listaCategoriasPromociones"
              label="nombreCategoriaPromocion"
              :reduce="(item) => item.idCategoriaPromocion"
              :clearable="true"
              >
          </v-select>
        </b-col>
      </b-row>

      <b-row class="text-left" style="margin-top: 18px;">
        <b-col cols="2">
          <label style="font-size: 12px">Tipo de Promo <validacion/> </label>
        </b-col>
        <b-col cols = "6">
          <v-select
              v-model="idTipoPromo"
              :options="tipoPromos"
              label="nombre"
              :reduce="(item) => item.id"
              :key="idTipoPromo-'tpd'"
              @input="seleccionTipoPromo()"
              :clearable="false"
              :class="selectClass(idTipoPromo !== null)"
          >
          </v-select>
        </b-col>
      </b-row>

      <b-row class="text-left" style="margin-top: 18px;">
        <b-col cols="2">
          <label style="font-size: 12px">Vigencia <validacion/> </label>
        </b-col>
        <b-col cols = "6">
          <div>
            <b-form-radio-group
                v-model="tipoVigenciaSelect"
                :options="optionsTipoVigencia"
                class="mb-3"
                value-field="id"
                text-field="nombre"
                stacked
            ></b-form-radio-group>
          </div>

          <div v-if="tipoVigenciaSelect == 1">
            <span style="color: #0069A9; font-size: 12px" >Si pagas un tratamiento o lo ejecutas</span>
            <b-row class="m-2">
              <b-col cols="1">
                <div style="width: 50px">
                  <strong style="font-size: 12px">Del <validacion/> </strong>
                </div>
              </b-col>
              <b-col>
              <b-form-datepicker :min="new Date()" placeholder="Fecha inicio" v-model="fechaInicioCompraEjecucion"
                                 :state="fechaInicioCompraEjecucion != null && fechaInicioCompraEjecucion !== '' "
              ></b-form-datepicker>
              </b-col>
            </b-row>
            <b-row class="m-2">
              <b-col cols="1">
                <div style="width: 50px">
                  <strong style="font-size: 12px">Al <validacion/> </strong>
                </div>
              </b-col>
              <b-col>
              <b-form-datepicker :min="new Date()" placeholder="Fecha fin" v-model="fechaFinCompraEjecucion"
                                 :state="fechaFinCompraEjecucion != null && fechaFinCompraEjecucion !== '' "
                                 :disabled="fechaInicioCompraEjecucion === null || fechaInicioCompraEjecucion === ''"
                                 @change="validacionEjecucion()"
              ></b-form-datepicker>
              </b-col>
            </b-row>
          </div>

          <div v-if="tipoVigenciaSelect == 2">
            <b-row >
              <b-col cols="6">
                <span style="color: #0069A9; font-size: 12px" >Si tu agendas</span>
                <b-row class="m-2">
                  <b-col cols="2">
                    <div style="width: 50px">
                      <strong style="font-size: 12px">Del <validacion/> </strong>
                    </div>
                  </b-col>
                  <b-col>
                    <b-form-datepicker :min="new Date()" placeholder="Fecha inicio" v-model="fechaInicioAgendas"
                                       :state="fechaInicioAgendas != null && fechaInicioAgendas !== '' "
                    ></b-form-datepicker>
                  </b-col>
                </b-row>
                <b-row class="m-2">
                  <b-col cols="2">
                    <div style="width: 50px">
                      <strong style="font-size: 12px">Al <validacion/> </strong>
                    </div>
                  </b-col>
                  <b-col>
                    <b-form-datepicker :min="new Date()" placeholder="Fecha Fin"  v-model="fechaFinAgendas"
                                       :state="fechaFinAgendas != null && fechaFinAgendas !== '' "
                                       :disabled="fechaInicioAgendas === null || fechaInicioAgendas === ''"
                    ></b-form-datepicker>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="6">
                <span style="color: #0069A9; font-size: 12px" >para asistir a una cita</span>
                <b-row class="m-2">
                  <b-col cols="2">
                    <div style="width: 50px">
                      <strong style="font-size: 12px" >Del <validacion/> </strong>
                    </div>
                  </b-col>
                  <b-col>
                    <b-form-datepicker :min="new Date()" placeholder="Fecha inicio" v-model="fechaInicioAsistirCita"
                                       :state="fechaInicioAsistirCita != null && fechaInicioAsistirCita !== '' "
                    ></b-form-datepicker>
                  </b-col>
                </b-row>
                <b-row class="m-2">
                  <b-col cols="2">
                    <div style="width: 50px">
                      <strong style="font-size: 12px">Al <validacion/></strong>
                    </div>
                  </b-col>
                  <b-col>
                    <b-form-datepicker :min="new Date()" placeholder="Fecha Fin"  v-model="fechaFinCompraAsistirCita"
                                       :state="fechaFinCompraAsistirCita != null && fechaFinCompraAsistirCita !== '' "
                                       :disabled="fechaInicioAsistirCita === null || fechaInicioAsistirCita === ''"
                    ></b-form-datepicker>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>

        </b-col>
      </b-row>

      <b-row class="text-left" style="margin-top: 18px;">
        <b-col cols="2">
          <label style="font-size: 12px">Promo Forzosa</label>
        </b-col>
        <b-col cols = "2" class="text-left" style="margin-left: -100px;">
          <b-form-checkbox v-model="promoForzosa" name="check-button" switch>
          </b-form-checkbox>
        </b-col>
      </b-row>
    </div>

    <hr>
<!--             Segmentacion clinicas       -->
    <div class="text-left">
      <span class="subEspacios">Segmentación de clínicas</span>

      <b-row class="text-left" style="margin-top: 18px;">
        <b-col cols="5">

          <b-row>
            <b-col cols="2">
              <label style="font-size: 12px">Regiones </label>
            </b-col>
            <b-col>
              <b-form-checkbox-group
                  v-model="regiones"
                  :options="zonas"
                  class="mb-3"
                  value-field="idPrecio"
                  text-field="nombreZona"
                  disabled-field="notEnabled"
                  stacked
                  @input="chequearClinicas()"
              ></b-form-checkbox-group>
            </b-col>
          </b-row>

        </b-col>
        <b-col cols = "7">
          <b-row>
            <b-col cols="2">
              <div style="width: 100px">
                <label style="font-size: 12px">Clínicas <validacion/> ({{listaSeleccionadaClinicas.length}})</label>
              </div>
            </b-col>
            <b-col >

              <listaFiltraComponente ref="listaFiltroClinicas" :placeholderBuscador="'Búsqueda de clínica'"
                                     :listaPrincipal.sync=" seleccionClinicaAutomatico ? listaClinicaByRegiones : listaClinicas"
                                     @listaCheckeada="listaSeleccionadaClinicas = $event"
                                     :vistaAgrupador="false"
                                     :selecionado-automatico="seleccionClinicaAutomatico"
              ></listaFiltraComponente>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>

    <hr>

    <div class="text-left">
      <span class="subEspacios">Segmentación de Pacientes</span>

      <b-row class="text-left" style="margin-top: 18px;">
        <b-col cols="5">

          <b-row>
            <b-col cols="2">
              <label style="font-size: 12px">Subtipo <validacion/> </label>
            </b-col>
            <b-col>
              <b-form-checkbox-group
                  v-model="idSubTipoPaciente"
                  :options="subtiposPaciente"
                  class="mb-3"
                  value-field="id"
                  text-field="descripcion"
                  disabled-field="notEnabled"
                  stacked
                  :state="idSubTipoPaciente != null && idSubTipoPaciente != false "
              ></b-form-checkbox-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols = "7">
          <b-row>
            <b-col cols="2">
              <label style="font-size: 12px"> Tipo <validacion/> </label>
            </b-col>
            <b-col >
              <b-form-checkbox-group
                  v-model="idsTipoPaciente"
                  :options="tiposPaciente"
                  class="mb-3"
                  value-field="id"
                  text-field="descripcion"
                  disabled-field="notEnabled"
                  stacked
                  :state="idsTipoPaciente.length > 0"
              ></b-form-checkbox-group>
              <b-form-checkbox v-if="blnMostrarPreguntaSegmenPlanes" v-model="blnMostrarSegmentacionPlanes" name="check-button" switch>¿QUIERES SUB-SEGMENTACIÓN DE PLAN?</b-form-checkbox>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>



    <div class="text-left" v-if="blnMostrarSegmentacionPlanes">
      <hr >
      <span class="subEspacios">Sub-Segmentación por plan</span>

      <b-row class="text-left" style="margin-top: 18px;">
        <b-col :class="(tipoSegmentacion === 2 && tipoSeleccionPlan === 2) ? 'col-12' : 'col-4'">
          <div>
            <div class="d-flex flex-column align-items-start">
              <label style="font-size: 12px">¿Como quieres Sub-Segmentar? <validacion/></label>
              <b-form-radio-group
                  v-model="tipoSegmentacion"
                  :options="optionsSegmentacionPlanes"
                  class="mb-3"
                  value-field="id"
                  text-field="nombre"
                  stacked
                  :state="tipoSegmentacion != null "
              ></b-form-radio-group>
            </div>
            <div class="d-flex flex-column align-items-start ml-5" v-if="tipoSegmentacion === 2">
              <label style="font-size: 12px">¿CÓMO QUIERES ESCOGER LOS PLANES? <validacion/></label>
              <b-form-radio-group
                  v-model="tipoSeleccionPlan"
                  :options="optionsTipoSeleccionPlanes"
                  class="mb-3"
                  value-field="id"
                  text-field="nombre"
                  stacked
                  :state="tipoSeleccionPlan != null "
              ></b-form-radio-group>
            </div>
              <b-row class="d-flex align-items-center ml-5" v-if="tipoSegmentacion === 2 && tipoSeleccionPlan === 2">
                   <b-col class="d-flex align-items-start">
                     <label style="font-size: 12px" class="mt-2">Tratamientos con descuento de planes <validacion/></label>
                     <v-select 
                                class="ml-3" :options="operadoresLogicos" 
                                label="nombre" tyle="width:29% !important"
                                placeholder="Selecciona un operador lógico." 
                                v-model="idOperadorLogico"
                                :reduce="(val) => val.id"
                     >

                     </v-select>
                     <b-input-group class="ml-3" style="width:10%">
                       <template #append>
                         <b-input-group-text
                         ><strong>%</strong></b-input-group-text>
                       </template>
                       <b-form-input
                           v-model="porcentajeSeleccionPlan"
                           type="number"
                           min="0"
                           max="100"
                           @paste.prevent
                           @keydown.prevent
                       ></b-form-input>
                     </b-input-group>
                   </b-col>
              </b-row>
          </div>
        </b-col>

        <b-col cols = "4" v-if="tipoSegmentacion === 1">
          <b-row>
            <b-col cols="2">
              <label style="font-size: 12px"> Cuentas<validacion/>({{listaSeleccionadaCuentas.length}}) </label>
            </b-col>
            <b-col >
                <listaFiltraComponente ref="listaFiltroCuentas" :placeholderBuscador="'Búsqueda de cuenta'" :listaPrincipal="listaCuentas"
                                       @listaCheckeada="listaSeleccionadaCuentas = $event"
              ></listaFiltraComponente>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols = "4" v-if="tipoSegmentacion === 1">
          <b-row>
            <b-col cols="2">
              <label style="font-size: 12px"> planes<validacion/> ({{listaSeleccionadaPlanes.length}})</label>
            </b-col>
            <b-col >
              <listaFiltraComponente ref="listaFiltroPlanes" :placeholderBuscador="'Búsqueda de plan'" :listaPrincipal="listaPlanes"
                                     @listaCheckeada="listaSeleccionadaPlanes = $event" :selecionadoAutomatico="true"
              ></listaFiltraComponente>
            </b-col>
          </b-row>
        </b-col>
          <b-col cols = "4" v-if="tipoSegmentacion === 2 && tipoSeleccionPlan === 1">
            <b-row>
              <b-col cols="2">
                <label style="font-size: 12px"> planes<validacion/> ({{listaSeleccionadaPlanesTipoSegmentacion.length}})</label>
              </b-col>
              <b-col >
                <listaFiltraComponente ref="listaFiltroPlanesTipoSegmentacion"  :placeholderBuscador="'Búsqueda de plan'" :listaPrincipal="listaSoloPlanes"
                                       @listaCheckeada="listaSeleccionadaPlanesTipoSegmentacion = $event"
                ></listaFiltraComponente>
              </b-col>
            </b-row>
          </b-col>
      </b-row>


    </div>

    <hr>

    <div class="text-left">
      <span class="subEspacios">Tratamientos</span>

      <b-row  style="margin-top: 18px;">
        <b-col cols="7">

          <b-row>
            <b-col>
              <label style="font-size: 12px">Selecciona para agregar <validacion/></label>
            </b-col>
            <b-col class="text-right"> <!--style="margin-left: 382px;"-->
              <em class="btn_plus_circle"
                  v-b-tooltip.hover.lefttop.v-light
                  title="Agregar con agrupador"
                  @click="showModal"
                  style="cursor: pointer"
              />
            </b-col>
          </b-row>

          <v-select :options="tratamientos" @input="agregarTratamiento($event)" label="nombreTratamiento"
                    placeholder="Selección de tratamientos para aplicar en los descuentos de zonas"
                    :clearable="false"
          ></v-select>
        </b-col>

        <b-col cols="4">
          <b-row>
            <b-col cols="2">
              <label style="font-size: 12px">Descuento</label>
            </b-col>
            <b-col>
              <nav >
                <ul>
                  <b-row
                      v-for="(zona, index1) in zonas"
                      :key="'z-des-'+index1"
                  >
                    <b-col>
                      <label>{{zona.nombreZona}}</label>
                    </b-col>
                    <b-col style="margin-bottom: 2px;">
                      <b-form-input
                          type="number"
                          v-model="zona.descuento"
                          :min="1"
                          onpaste="return false;"
                          @keydown="filterJustNumber($event)"
                          @keyup="validarDescZona(zona)"
                          :state="zona.descuento != null && zona.descuento !== '' "
                      ></b-form-input>
                    </b-col>


                  </b-row>
                </ul>
              </nav>
            </b-col>
          </b-row>




        </b-col>
      </b-row>


      <br/>
      <div>
        <label style="font-size: 12px">Listado Tratamientos <validacion/> </label>

        <b-row>
          <b-col cols="3"></b-col>
          <b-col cols="8" md="6" >
            <b-row class="contenedorTablaSinColor" style="background:white ">
              <b-col cols="10" lg="11" class="pr-0">
                <b-input-group class="pl-3" >
                  <b-form-input
                      class="input-filter"
                      maxLength="15"
                      type="search"
                      id="filterInput"
                      responsive
                      placeholder="Búsqueda de Tratamientos"
                      v-model="nombreTratamiento"
                      @keydown.enter.native="buscarTratamientos"
                  >
                  </b-form-input>

                </b-input-group>
              </b-col>
              <b-col cols="2" lg="1" class="pl-0">
                <b-button
                    class="mt-1 pb-1"
                    size="sm"
                    pill
                    variant="info"
                    responsive
                >
                  <em class="buscar_svg info sm"></em>
                </b-button>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="2" class="text-right">
            <em class="trash_svg"
                style="cursor: pointer; padding-top: 12px;"
                @click="eliminarTodo()"
                v-b-tooltip.hover.right.v-ligth
                title="Eliminar todo"
            />
          </b-col>
        </b-row>



        <br/>

        <div class="contenedorTablaSinColor" style=" height: 480px; overflow-y: scroll ; ">
          <b-row class="textoPequeño" style="margin-top: 4px; font-weight: 600">
            <b-col cols="4" class="text-center">Tratamiento</b-col>
            <b-col cols="7">
              <b-row>
                <b-col  v-for="(zona, i) in zonas" :key="i">
                  <span>{{ zona.nombreZona }}</span>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="1">Acciones</b-col>

          </b-row>
          <hr/>
          <div v-for="(tr, ind ) in listaFiltro.length > 0 ? listaFiltro : tratamientosAgregados" :key="ind" >
            <b-row >

              <b-col cols="4" class="textoPequeño" >{{ tr.nombreTratamiento }}</b-col>

              <b-col cols="7" class="text-left">
                <b-row>
                  <b-col  v-for="(z, i) in tr.zonas" :key="i" style="display: ruby; margin-left: 1%;">
                    <span style="color: #65C045; font-weight: 600" v-if="idTipoPromo == 2"> $ </span>
                    <b-form-input maxlength="4"
                                  v-model="z.descuento"
                                  type="number"
                                  class="form-control-sm" style="width: 76px"
                                  :state="z.descuento != null && z.descuento !== '' "
                                  @keydown="filterJustNumber($event)"
                                  >
                    </b-form-input>
                    <span style="color: #65C045; font-weight: 600" v-if="idTipoPromo == 1"> % </span>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="1" class="text-left" style="padding-left: 2%;">
                <em class="trash_svg" @click="eliminarRegistro(ind)" style="cursor: pointer; "
                    v-b-tooltip.hover.right.v-ligth
                    title="Eliminar"/>
              </b-col>

            </b-row>
            <hr style="    margin-top: 4px;"/>
        </div>



        </div>
        <br/>
        <div class="text-center">
          <b-button v-if="estado !== 3"
              style="width: 160px;"
              variant="info"
              :disabled="loaderGuardar"
              @click="validacionesDatosForm()"
              pill
          >
            <span v-if="!loaderGuardar">Crear</span>
            <span v-if="loaderGuardar">
                <b-spinner small></b-spinner>
                Cargando...
              </span>
          </b-button>
        </div>


      </div>

    </div>

  </b-card>


  <b-modal ref="modal-agrupador"
           hide-footer
           size="lg"
           no-close-on-backdrop
           no-close-on-esc
           >
    <template v-slot:modal-header>
      <span style="color: #044169; font-weight: 600">Agregar tratamientos por agrupador </span>
    </template>
    <div >
     <AgrupadorPromos :lstTratamientosProp="tratamientos"
                      :lstCategoriasProp="listaCategorias"
                      :lstEdadPaciente="lstEdadPaciente"
                      @hideModal="hideModal"
                      @agregarPorAgrupador="agregarPorAgrupador"
                      :tratamientosPadre="tratamientosPadre"
     />
    </div>
  </b-modal>

</div>
</template>

<script>
import listaFiltraComponente from "../../views/promocionesV2/componentes/listaFiltraComponente";
import {CatalogosService} from "@/apiServices/catalogos/CatalogosService";
import Header from "@/components/Header";
import AgrupadorPromos from "@/views/promocionesV2/componentes/AgrupadorPromos";

export default {
  name: "promocionesV2",
  components: {
    AgrupadorPromos,
    Header,
    listaFiltraComponente

  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      loaderFull: false,
      catalogosService: new CatalogosService(),
      promoForzosa: false,
      nombrePromo: null,
      idCategoriaPromocion: null,
      idTipoPromo: null,
      idSubTipoPaciente: [],
      idsTipoPaciente: [],
      tratamientos: [],
      regiones: [],
      tratamientosAgregados: [],
      listaClinicas: [],
      listaCuentas:[],
      listaPlanes:[],
      listaSoloPlanes:[],
      lstEdadPaciente:[
        {
          id: 1,
          nombre: 'Infantil'
        },
        {
          id: 2,
          nombre: 'Adulto'
        },
        {
          id: 3,
          nombre: 'Mixto'
        },
      ],
      listaSeleccionadaClinicas:[],
      listaSeleccionadaCuentas:[],
      listaSeleccionadaPlanes:[],
      listaSeleccionadaPlanesTipoSegmentacion:[],
      listaLimpiaPlanesCuentas:[],
      categorias: [],
      tipoPromos: [],
      subtiposPaciente:[],
      tiposPaciente: [],
      zonas: [],
      optionsTipoVigencia: [],
      optionsSegmentacionPlanes: [],
      optionsTipoSeleccionPlanes: [],
      tipoVigenciaSelect: 1,
      idPromocion: null,
      idOperadorLogico: null,


      tipoSegmentacion: null,
      tipoSeleccionPlan: null,
      idRegion: null,
      listaCategorias:[],
      listaCategoriasPromociones:[],
      max: null,
      lstEspecialidades:[],
      operadoresLogicos: [],
      operadorLogicoSeleccionado:null,
      porcentajeSeleccionPlan: 0,
      nombreTratamiento: null,
      loaderGuardar: false,
      fechaInicioCompraEjecucion: null,
      fechaFinCompraEjecucion: null,
      fechaInicioAgendas: null,
      fechaFinAgendas: null,
      fechaInicioAsistirCita: null,
      fechaFinCompraAsistirCita: null,
      blnMostrarPreguntaSegmenPlanes: false,
      blnMostrarSegmentacionPlanes: false,
      listaFiltro: [],
      seleccionClinicaAutomatico: false,
      listaClinicaByRegiones: [],
      tratamientosPadre: [],
      estado: null,
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.obtenerCatalogos();
    if(this.tipoSegmentacion === 1){
      this.obtenerCuentasActivas();
    }
    this.idPromocion = this.$route.params.id;

  },
  watch: {
    listaSeleccionadaCuentas() {
        this.obtenerPlanesActivasPorCuenta();
    },
    tipoSegmentacion() {

      if (this.idPromocion == null){
        this.listaCuentas=[];
        this.listaPlanes=[];
        this.listaSoloPlanes=[];
        this.idOperadorLogico = null;
        this.porcentajeSeleccionPlan = null;
        this.tipoSeleccionPlan = null;
        this.listaSeleccionadaCuentas = [];
        this.listaSeleccionadaPlanes = [];
      }

      if(this.tipoSegmentacion === 1){
        this.obtenerCuentasActivas();
      }else if(this.tipoSegmentacion === 2){
        this.obtenerPlanesActiva();
      }
    },
    tipoSeleccionPlan(){
      if (this.idPromocion == null) {
        this.idOperadorLogico = null;
        this.porcentajeSeleccionPlan = null;
        this.listaSeleccionadaCuentas = [];
        this.listaSeleccionadaPlanes = [];
      }
    },
    blnMostrarSegmentacionPlanes(){
      if(!this.blnMostrarSegmentacionPlanes){
        this.listaCuentas=[];
        this.listaPlanes=[];
        this.listaSoloPlanes=[];
        this.idOperadorLogico = null;
        this.porcentajeSeleccionPlan = null;
        this.tipoSeleccionPlan = null;
        this.listaSeleccionadaCuentas = [];
        this.listaSeleccionadaPlanes = [];
        this.tipoSegmentacion = null;
      }
    },
    idsTipoPaciente(){
      let objetoDienteEncontrado = this.idsTipoPaciente.find(objeto => objeto === 2);
         if(objetoDienteEncontrado != null){
           this.blnMostrarPreguntaSegmenPlanes = true;
         }else{
           this.blnMostrarPreguntaSegmenPlanes = false;
           this.blnMostrarSegmentacionPlanes = false;
         }
    },
 /*   idSubTipoPaciente(){
      if (this.idSubTipoPaciente.filter(f => f.id === 3)){
        this.idsTipoPaciente = new Array(1,2,3,4)
        console.log(this.idsTipoPaciente)
      }
    }*/
    fechaFinCompraEjecucion(){
      var inicio = new Date(this.fechaInicioCompraEjecucion);
      var fin = new Date(this.fechaFinCompraEjecucion);
      if (inicio > fin){
        this.fechaInicioCompraEjecucion = null;
        this.mensajeDeValidacionCalendario("Las fechas proporcionadas no son correctas.Por favor, verifica las fechas e inténtalo de nuevo.");
      }
    },
    fechaFinAgendas(){
      var inicio1 = new Date(this.fechaInicioAgendas);
      var fin1 = new Date(this.fechaFinAgendas);
      if (this.fechaInicioAgendas !== null && this.fechaFinAgendas !== null && inicio1 > fin1){
        this.fechaInicioAgendas = null;
        this.fechaInicioAgendas = "";
        this.mensajeDeValidacionCalendario("Las fechas proporcionadas no son correctas.Por favor, verifica las fechas e inténtalo de nuevo.1");
      }
    },
    fechaFinCompraAsistirCita(){
      var inicio2 = new Date(this.fechaInicioAsistirCita);
      var fin2 = new Date(this.fechaFinCompraAsistirCita);
      var inicio1 = new Date(this.fechaInicioAgendas);
      //var fin1 = new Date(this.fechaFinAgendas);
      if (this.fechaInicioAsistirCita !== null && this.fechaFinCompraAsistirCita !== null && inicio2 > fin2){
        this.fechaInicioAsistirCita = null;
        this.mensajeDeValidacionCalendario("Las fechas proporcionadas no son correctas.Por favor, verifica las fechas e inténtalo de nuevo.2");
      }
      if ((this.fechaInicioAgendas !== null && this.fechaFinAgendas) &&
          (this.fechaInicioAsistirCita !== null && this.fechaFinCompraAsistirCita) !== null && (inicio2 < inicio1)){
        this.fechaInicioAsistirCita = null;
        this.mensajeDeValidacionCalendario("Las fechas proporcionadas no son correctas.Por favor, verifica las fechas e inténtalo de nuevo.3");
      }
    }
  },
  methods: {
    obtenerCatalogos(){
      this.obtenerTratamientos();
      this.obtenerTratamientosPadre();
      this.obtenerClinicas();
      this.obtenerSubTipoPaciente();
      this.obtenerTipoPaciente();
      this.obtenerZonas();
      this.obtenerCategorias();
      this.obtenerCategoriasPromociones();
      this.obtenerTipoEscogerPlanPromocionActivas();
      this.obtenerOperadorLogicoPromocionActivas();
      this.obtenerSubSegmentarPlanPromocionActivas();
      this.obtenerTipoVigenciaPromocionActivas();
      this.obtenerTipoDescPromo();
    },

    mensajeDeValidaciones(mensaje) {
      this.$swal
          .fire({
            icon: "warning",
            title: "Lo sentimos: ",
            confirmButtonColor: "#0e6ba9",
            confirmButtonText: "OK",
            html: '<div style="font-weight: 500">'+mensaje+'</div>',
          })
      },
    mensajeDeValidacionCalendario(mensaje) {
      this.$swal
          .fire({
            icon: "warning",
            title: "Lo sentimos: ",
            confirmButtonColor: "#0e6ba9",
            confirmButtonText: "OK",
            allowOutsideClick: false,
            allowEscapeKey: false,
            html: '<div style="font-weight: 500">'+mensaje+'</div>',
          }).then((aceptar) => {
              if (aceptar.value) {
                this.fechaInicioCompraEjecucion = null;
                this.fechaFinCompraEjecucion = null;
                this.fechaInicioAgendas = null;
                this.fechaFinAgendas = null;
                this.fechaInicioAsistirCita = null;
                this.fechaFinCompraAsistirCita = null;
              }
           })
    },

    validacionesDatosForm() {

      /*   Validamos tipo de vigencia "Compra / Ejecución"  */
      if (this.nombrePromo == null || this.nombrePromo == '') {
        this.mensajeDeValidaciones("Asigne un nombre a la promoción.")
      }else if (this.tipoVigenciaSelect === 1 && (this.fechaInicioCompraEjecucion == null || this.fechaFinCompraEjecucion == null)) {
          this.mensajeDeValidaciones("Por favor, complete los datos de vigencia.")
      } else if (this.idTipoPromo === null) {
        this.mensajeDeValidaciones("Por favor, seleccione un tipo de promoción.")
      } else if (this.tipoVigenciaSelect === 2 && (this.fechaInicioAgendas == null || this.fechaFinAgendas == null) && (this.fechaInicioAsistirCita == null || this.fechaFinCompraAsistirCita == null)) {
        this.mensajeDeValidaciones("Por favor, complete los datos de vigencia.")
      } else if (this.listaSeleccionadaClinicas.length === 0) {
        this.mensajeDeValidaciones("Por favor, seleccione una clínica.")
      } else if (this.idSubTipoPaciente == null || this.idSubTipoPaciente.length == 0 || this.idSubTipoPaciente == [] ) {
        this.mensajeDeValidaciones("Faltan datos en segmentación de pacientes.")
      } else if (this.tratamientosAgregados.length === 0) {
        this.mensajeDeValidaciones("Por favor, Agrega tratamientos a la promoción.")
      } else if (this.blnMostrarSegmentacionPlanes === true && this.tipoSegmentacion == null) {
        this.mensajeDeValidaciones("Por favor, selecciona, ¿cómo quieres sub-segmentar?.")
      } else if (this.blnMostrarSegmentacionPlanes === true && this.tipoSegmentacion === 1 && this.listaSeleccionadaCuentas.length === 0) {
        this.mensajeDeValidaciones("Por favor, selecciona al menos una cuenta.");
      } else if (this.blnMostrarSegmentacionPlanes === true && this.tipoSegmentacion === 1 && this.listaSeleccionadaPlanes.length === 0) {
        this.mensajeDeValidaciones("Por favor, selecciona al menos un plan.")
      } else if (this.blnMostrarSegmentacionPlanes === true && this.tipoSegmentacion === 2 && this.tipoSeleccionPlan === null) {
        this.mensajeDeValidaciones("Por favor, selecciona, ¿cómo quieres escoger los planes?")
      } else if (this.blnMostrarSegmentacionPlanes === true && this.tipoSegmentacion === 2 && this.tipoSeleccionPlan === 1 && this.listaSeleccionadaPlanesTipoSegmentacion.length === 0) {
        this.mensajeDeValidaciones("Por favor, selecciona al menos un plan.")
      } else if (this.blnMostrarSegmentacionPlanes === true && this.tipoSegmentacion === 2 && this.tipoSeleccionPlan === 2 && this.idOperadorLogico === null) {
        this.mensajeDeValidaciones("Por favor, selecciona un operador lógico.")
      } else if (this.blnMostrarSegmentacionPlanes === true && this.tipoSegmentacion === 2 && this.tipoSeleccionPlan === 2 && (this.porcentajeSeleccionPlan === null || this.porcentajeSeleccionPlan === '0')) {
        this.mensajeDeValidaciones("Por favor, ingresa un porcentaje.")
      } else {
      //  alert("guardooo")
        this.guardar();
      }

    },

    guardar() {
        this.loaderGuardar = true;

      const idsClinicas = [];
      this.listaSeleccionadaClinicas.forEach(c => {idsClinicas.push(c.id) })
      const parametros = {
        idPromocion: this.idPromocion,
        nombrePromo: this.nombrePromo,
        idCategoria: this.idCategoriaPromocion,
        idTipoDescPromo: this.idTipoPromo,
        idTipoVigencia: this.tipoVigenciaSelect,
        idsRegiones: this.regiones,
        idsClinicas: idsClinicas,
        idSubTipoPaciente: this.idSubTipoPaciente,
        idsTipoPaciente: this.idsTipoPaciente,
        idTipoSegmentacionPlan: this.tipoSegmentacion, //por plan o por cuenta
        idtipoEscogerPlan: this.tipoSeleccionPlan,
        idOperadorLogico: this.idOperadorLogico != null ? this.idOperadorLogico : null,
        valorReglaOperador: this.porcentajeSeleccionPlan,
        tratamientos: this.tratamientosAgregados,
        promoForzosa: this.promoForzosa,
        fechaInicio: this.fechaInicioCompraEjecucion,
        fechaFin: this.fechaFinCompraEjecucion,

        fechaInicioAgendamiento: this.fechaInicioAgendas,
        fechaFinAgendamiento: this.fechaFinAgendas,
        fechaInicioCita: this.fechaInicioAsistirCita,
        fechaFinCita: this.fechaFinCompraAsistirCita,
        listaPlanesCuenta: this.listaSeleccionadaPlanes == null || this.listaSeleccionadaPlanes.length === 0 ? this.listaSeleccionadaPlanesTipoSegmentacion : this.listaSeleccionadaPlanes,

      }
      this.$http
          .post(this.$api + "promocionV2/guardarPromo", parametros)
          .then((response) => {
            console.log(response.data.data)

            this.$swal({
              icon: "success",
              text: "La Promo se registró correctamente",
              confirmButtonText: "De acuerdo",
              confirmButtonColor: "#0e6ba9",
              onClose: () => {
                this.$router.push({
                  name: "ListaPromociones",
                });
              },
            });
          }).finally (() => {
            this.loaderGuardar = false;
      })
    },

    obtenerPromocionConfigurada(){
      this.loaderFull = true;
      const params = {
        idPromocion: this.idPromocion
      }
      this.$http.post(this.$api + 'promocionV2/obtenerPromoById', params ).then(respuesta => {
        if (respuesta.data.data) {
            const data = respuesta.data.data

          this.listaClinicas.forEach(lc => {
            data.idsClinicas.forEach(c => {
              if (lc.id == c){
                this.listaSeleccionadaClinicas.push(lc)
              }
            })
          })
          this.listaSeleccionadaClinicas.forEach(c =>  c.seleccionado = true  )

          this.listaSeleccionadaClinicas.forEach(c => {
            c.seleccionado = true
          })


               this.idPromocion = data.idPromocion;
               this.nombrePromo = data.nombrePromo;
               this.idCategoriaPromocion = data.idCategoria;
               this.idTipoPromo = data.idTipoDescPromo;
               this.tipoVigenciaSelect = data.idTipoVigencia;

               /*idsClinicas*/
               this.idSubTipoPaciente = data.idSubTipoPaciente;
               this.idsTipoPaciente = data.idsTipoPaciente;
               this.tipoSegmentacion = data.idTipoSegmentacionPlan; //por plan o por cuenta
               this.tipoSeleccionPlan = data.idtipoEscogerPlan;
               this.idOperadorLogico = data.idOperadorLogico;
               this.porcentajeSeleccionPlan = data.valorReglaOperador;
               this.tratamientosAgregados = data.tratamientos;
               this.promoForzosa = data.promoForzosa;
               this.fechaInicioCompraEjecucion = data.fechaInicio;
               this.fechaFinCompraEjecucion = data.fechaFin;

               this.fechaInicioAgendas = data.fechaInicioAgendamiento;
               this.fechaFinAgendas = data.fechaFinAgendamiento;
               this.fechaInicioAsistirCita = data.fechaInicioCita;
               this.fechaFinCompraAsistirCita = data.fechaFinCita
               this.listaLimpiaPlanesCuentas = data.listaPlanesCuenta;
               this.estado = data.estado;
               this.blnMostrarSegmentacionPlanes = data.blnMostrarSegmentacionPlanes;


          this.$refs.listaFiltroClinicas.filtrarListaPorCoincidencia();

          this.loaderFull = false;
        }
      })

    },


    buscarTratamientos(){
       this.listaFiltro = this.tratamientosAgregados;
      if (this.nombreTratamiento !== null && this.nombreTratamiento !== '') {
        this.listaFiltro = this.tratamientosAgregados.filter(item => item.nombreTratamiento.toLowerCase().includes((this.nombreTratamiento.toLowerCase())));
      }else{
        this.listaFiltro = []
      }
    },
    seleccionTipoPromo(){
      this.max = this.idTipoPromo == 1 ?  4 :  3


      this.tratamientosAgregados.forEach(ta => {
        ta.zonas.forEach(z => {
            z.descuento = 0;

        })
      })



      this.zonas.forEach(z => {
        z.descuento = 0;
      })
    },
    chequearClinicas(){

      if (this.regiones.length === 0){
        this.listaClinicas.forEach(c => {
          c.seleccionado = false;
        })
        this.seleccionClinicaAutomatico = false;
        this.listaClinicas.map(i => {i.seleccionado = false; return i});
        this.$refs.listaFiltroClinicas.filtrarListaPorCoincidencia();
      }
      else {
      //  this.listaPlanes = resp.data.data.map(i => {i.seleccionado = true; return i});
        this.listaClinicaByRegiones = []
        this.seleccionClinicaAutomatico = true;
        this.regiones.forEach(r => { this.listaClinicas.forEach(c => {
          if (c.idPrecio === r){
            this.listaClinicaByRegiones.push(c)
          }
        })
        })

        this.listaClinicaByRegiones.map(i => {i.seleccionado = true; return i});
        this.$refs.listaFiltroClinicas.filtrarListaPorCoincidencia();
      }




    },

    obtenerClinicas() {
      this.catalogosService.listaClinicasNombreId().then((response) => {
        this.listaClinicas = response;
        this.$refs.listaFiltroClinicas.filtrarListaPorCoincidencia();
      }).finally(() => {
        if (this.idPromocion != 0){
          this.obtenerPromocionConfigurada();
        }
      });
    },


    validarDescZona(zona){
      if (this.idTipoPromo == 1){
        zona.descuento = zona.descuento > 100 ? 100 : zona.descuento
      }


      if (this.tratamientos.length > 0){
        this.tratamientos.forEach(ta => {
          ta.zonas.forEach(z => {
            if (z.idPrecio == zona.idPrecio){
              z.descuento = zona.descuento;
            }
          })
        })
      }

      if (this.tratamientosAgregados.length > 0){
        this.tratamientosAgregados.forEach(ta => {
          ta.zonas.forEach(z => {
            if (z.idPrecio == zona.idPrecio){
              z.descuento = zona.descuento;
            }
          })
        })
      }

    },
    eliminarTodo(){
      this.tratamientosAgregados = [];
    },
    agregarTratamiento(event){
      if (this.tratamientosAgregados.length == 0){
          this.tratamientosAgregados.push(event);
      }else {
        let distintos = [];
          if (!this.tratamientosAgregados.includes(event)){
            distintos.push(event)
          }
        distintos.forEach(d => {
          this.tratamientosAgregados.unshift(d)
        })

      }
    },
    agregarPorAgrupador(tratamientos){
      if (this.tratamientosAgregados.length == 0){
        tratamientos.forEach(t => {
            this.tratamientosAgregados.push(t);
        })
      }else {
        let distintos = [];
        tratamientos.forEach(t => {
          if (!this.tratamientosAgregados.includes(t)){
            distintos.push(t)
          }
        })
        distintos.forEach(d => {
          this.tratamientosAgregados.unshift(d)
        })

      }

    },
    eliminarRegistro(index){
      this.tratamientosAgregados.splice(index, 1);
    },
    obtenerTipoPaciente() {
      this.catalogosService.obtenerTipoPaciente().then((response) => {
        this.tiposPaciente = response.data;
       // this.tiposPaciente.unshift({id: 0, descripcion: 'Todos'})
      });
    },
    obtenerCategorias() {
      this.$http.get(this.$api + 'catalogos/listaCategorias',).then(resp => {
        this.listaCategorias = resp.data.data
      })
    },
    obtenerTipoDescPromo() {
      this.$http.get(this.$api + 'promocionV2/obtener/tipoDescPromo',).then(resp => {
        this.tipoPromos = resp.data.data
      })
    },
    obtenerTratamientos() {

      this.$http.post(this.$api + 'tratamientos/obtenerTratamientosVistaPromos',).then(respuesta => {
        if (respuesta.data.data){
          this.tratamientos = respuesta.data.data.filter(d => d.registroActivo);
        }
      })

    },
    obtenerTratamientosPadre() {
      this.$http.get(this.$api + 'tratamientos/obtenerTratamientosPadre',).then(respuesta => {
        if (respuesta.data.data){
          this.tratamientosPadre = respuesta.data.data;
        }
      })
    },
    obtenerSubTipoPaciente() {
      this.catalogosService.obtenerSubTipoPaciente().then((response) => {
        this.subtiposPaciente = response.data;
      });
    },
    obtenerZonas() {
      this.catalogosService.listaZonas().then((response) => {
        this.zonas = response.map((z) => {
          z.dato = 0;
          z.datoI = 0;
          return z;
        });
      });
    },

    showModal() {
      this.$refs['modal-agrupador'].show()
    },
    hideModal() {
      this.$refs['modal-agrupador'].hide()
    },
    toggleModal() {
      this.$refs['modal-agrupador'].toggle('#toggle-btn')
    },
    obtenerCuentasActivas() {
      this.$http.get(this.$api + 'promocionV2/catalogos/obtenerCuentasActivas',).then(resp => {
        this.listaCuentas = resp.data.data;

        if (this.idPromocion !== 0){
          this.listaCuentas.forEach( p => {
            if (this.listaLimpiaPlanesCuentas.find(l => l.idCuenta === p.id)){
              p.seleccionado = true
            }
          })
        }


        this.$refs.listaFiltroCuentas.filtrarListaPorCoincidencia();
      })
    },
    obtenerPlanesActivasPorCuenta() {
      this.listaPlanes = [];
      this.$http.post(this.$api + 'promocionV2/catalogos/obtenerPlanesPorCuenta',this.listaSeleccionadaCuentas).then(resp => {
        if(this.listaSeleccionadaCuentas.length > 0){
          this.$refs.listaFiltroPlanes.noPerderNoSeleccionados();
          this.listaPlanes = resp.data.data.map(i => {i.seleccionado = true; return i});
          this.$refs.listaFiltroPlanes.agregarNoSeleccionados();
        }
      })
    },
    obtenerPlanesActiva() {
      this.listaSoloPlanes = [];
      this.$http.get(this.$api + 'promocionV2/catalogos/obtenerPlanesActivas').then(resp => {
        this.listaSoloPlanes = resp.data.data;

        if (this.idPromocion !== 0 ){
          this.listaSoloPlanes.forEach( p => {
            if (this.listaLimpiaPlanesCuentas.find(l => l.id === p.id)){
              p.seleccionado = true
            }
          })
        }


        this.$refs.listaFiltroPlanesTipoSegmentacion.filtrarListaPorCoincidencia();
      })
    },
    agregarOperadorLogico(operadorLogico){
      this.operadorLogicoSeleccionado = operadorLogico;
    },
    soloNumeros(e){
      e.target.value = e.target.value.replace(/[^0-9]+/g, '');
    },
    filterJustNumber(e){
      const key = e.key;

      if (key === '-'){
        return e.preventDefault();
      }

      if (key === '.'){
        return e.preventDefault();
      }

      // OPTIONAL
      // If is 'e' key, stop it
      if (key === 'e'){
        return e.preventDefault();
      }

    },
    obtenerCategoriasPromociones() {
      this.$http.get(this.$api + 'categoriaPromocion/obtenerCategoriasPromocionActivas',).then(resp => {
        this.listaCategoriasPromociones = resp.data.data
      })
    },
    obtenerTipoEscogerPlanPromocionActivas() {
      this.optionsTipoSeleccionPlanes = [];
      this.$http.get(this.$api + 'promocionV2/catalogos/obtenerTipoEscogerPlanPromocionActivas',).then(resp => {
        this.optionsTipoSeleccionPlanes = resp.data.data
      })
    },
    obtenerOperadorLogicoPromocionActivas() {
      this.operadoresLogicos = [];
      this.$http.get(this.$api + 'promocionV2/catalogos/obtenerOperadorLogicoPromocionActivas',).then(resp => {
        this.operadoresLogicos = resp.data.data;
      })
    },
    obtenerSubSegmentarPlanPromocionActivas() {
      this.optionsSegmentacionPlanes = [];
      this.$http.get(this.$api + 'promocionV2/catalogos/obtenerSubSegmentarPlanPromocionActivas',).then(resp => {
        this.optionsSegmentacionPlanes = resp.data.data;
      })
    },
    obtenerTipoVigenciaPromocionActivas() {
      this.optionsTipoVigencia = [];
      this.$http.get(this.$api + 'promocionV2/catalogos/obtenerTipoVigenciaPromocionActivas',).then(resp => {
        this.optionsTipoVigencia = resp.data.data
      })
    },
    selectClass(state) {
      if (state) {
        return 'border rounded-lg border-success'
      } else if (state === false) {
        return 'border rounded-lg border-danger'
      } else {
        return ''
      }
    }

  }
}
</script>

<style scoped>
.subEspacios{
  color: #17A2B8;
  font-weight: 600;
}
.textoPequeño{
  font-size: 12px;
  color: black;
}
.input-group-text {
  background-color: #FFFFFF !important;
}
</style>
